﻿import { deleteParameterAlert, deleteWaveBuoyExcursionAlarm, setParameterAlert, setWaveBuoyExcursionAlarm } from "../API/Alerts/Alerts";
import { SetWaveBuoyExcursionAlarmRequest } from "../API/Alerts/SetWaveBuoyExcursionAlarmRequest";
import { RESTError } from "../API/RESTError";
import { ParameterSchemaSensor, ParameterInfo, ParameterVariant } from "../API/Schema/ParameterSchema";
import { IHashData } from "../IHashData";
import { IPage } from "../IPage";
import { MainSite } from "../MainSite";
import { ParameterRangeEmailAlert } from "../Model/ParameterRangeEmailAlert";
import { IRegion, IStationsByRegion } from "../Model/Region";
import { WaveBuoyTargetLocation } from "../Model/WaveBuoyTargetLocation";

interface AlertNamesStruct {
    station: string;
    sensor: string;
    parameter: string;
}

export class ManageAlertsPage implements IPage {
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'manageAlerts';

    public initialize(): void {
    }

    private container: JQuery = null;
    private loadingContainer: JQuery = null;
    private modal: JQuery = null;
    private modalContent: JQuery = null;
    private modalBodyContent: JQuery;
    private modalFieldStationId: JQuery;
    private modalFieldParameterGroup: JQuery;
    private modalFieldSensor: JQuery;

    private emailRecipientInput: JQuery = null;
    private selectStationDropdown: JQuery = null;
    private targetLatitudeInput: JQuery = null;
    private targetLongitudeInput: JQuery = null;
    private maxExcursionInput: JQuery = null;
    private activeInput: JQuery = null;

    private table: JQuery = null;
    private tableBody: JQuery = null;
    private tableHead: JQuery = null;
    private tableHeadRow: JQuery = null;

    private WAVE_BUOY_PARAMETER_IDS: string[] = ['Buoy_Excursion/m', 'Buoy_Latitude/deg', 'Buoy_Longitude/deg']; // 'Buoy_BatteryLife/weeks', 'Buoy_BatteryVoltage/V',

    private alertsListWaveBuoy: ParameterRangeEmailAlert[] = []; //: list of WaveBuoy alerts (to help avoid re-listing them in the non-wave buoy alerts..)

    public handleHashChange(hashData: IHashData): boolean {
        if (hashData.Page === this.id) {
            if (!this.container) {
                this.refresh();
            }
            return true;
        } else {
            if (this.modal) {
                this.modal.modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                this.modal.remove();
                this.modal = null;
            }
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
            return false;
        }
    }

    private refresh(): void {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }

        this.container = $('<div class="container"></div>').appendTo('body');
        this.loadingContainer = $('<div class="alert alert-info"><i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...</div>').appendTo(this.container);

        this.mainSite.staticDataManager.getStaticData((err) => {
            if (err) {
                this.loadingContainer.removeClass('alert-info').addClass('alert-danger').html('<i class="fa fa-lg fa-fw fa-warning"></i> Uable to get list of settings from server: ' + err);
            } else {
                this.loadingContainer.removeClass('alert-danger').addClass('alert-info').html('<i class="fa fa-lg fa-fw fa-refresh fa-spin"></i> Loading...');
            }

            this.render();
        });
    }

    private render(): void {
        $('<h1 class="midi_manageUsersPage_title">Manage Alerts</h1>').appendTo(this.container);
        if (this.mainSite.currentUser.Permissions.GlobalAdministrator) {
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Global Administrator</strong>, you can  manage alerts across all regions.</p>').appendTo(this.container);
        } else {
            var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[this.mainSite.currentUser.Region];
            $('<p class="midi_manageUsersPage_topParagraph">As a <strong>Regional Administrator</strong> for the <strong>' + region.Label + '</strong> region, you can manage alerts for sites within your region.</p>').appendTo(this.container);
        }

        $('<p class="text-muted"><i class="fa fa-lg fa-info-circle"></i> <em><strong>Wave Buoy Alerts</strong> allow to specify the maximum excursion permitted for a buoy\'s movements, whereas <strong>Parameter Alerts</strong> allow to set Min and Max limits on any other Parameter.</em></p>').appendTo(this.container);

        let $tblTitleBar: JQuery = $('<div>').addClass('clearfix').appendTo(this.container);
        $tblTitleBar.css({ marginTop: 30, marginBottom: 15 });
        $('<h4 class="pull-left">Wave Buoy Alerts</h4>').appendTo($tblTitleBar);
        $('<button type="button" class="btn btn-success pull-right"><i class="fa fa-bell"></i> Add Wave Buoy Alert</button>')
            .appendTo($tblTitleBar)
            .click(() => {
                this.renderModal(null);
            });

        this.table = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        this.tableBody = $('<tbody></tbody>').appendTo(this.table);
        this.tableHead = $('<thead></thead>').appendTo(this.table);
        this.tableHeadRow = $('<tr></tr>').appendTo(this.tableHead);
        $('<th>Station</th> <th>Sensor</th> <th>Target Latitude</th> <th>Target Longitude</th> <th>Max Excursion (m)</th> <th>Email Recipients</th> <th class="text-center">Active</th> <th></th> <th></th>').appendTo(this.tableHeadRow);

        this.mainSite.staticDataManager.Schema.WaveBuoyTargetLocations.forEach(wbtl => {
            const alerts = this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.filter(x => x.StationId == wbtl.StationId && x.SensorId == wbtl.SensorId && this.WAVE_BUOY_PARAMETER_IDS.indexOf(x.ParameterId) >= 0);
            if (alerts.length != 1) {
                return; // we should never get here!!!
            }
            const alert = alerts[0];

            this.alertsListWaveBuoy.push(alert);

            var tableCurrentRow = $('<tr></tr>')
                .appendTo(this.tableBody);

            // add cells:
            $('<td></td>').text(this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[wbtl.StationId].Station.Label).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.SensorId).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.Latitude).appendTo(tableCurrentRow);
            $('<td></td>').text(wbtl.Longitude).appendTo(tableCurrentRow);
            $('<td></td>').text(alert.MaxValue).appendTo(tableCurrentRow);
            $('<td></td>').text(alert.EmailRecipients.join(", ")).css({ maxWidth: '40vw' }).appendTo(tableCurrentRow);
            $('<td></td>').html(alert.Active ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times"></i>').addClass('text-center').appendTo(tableCurrentRow);

            var editButtonCell = $('<td class="edit_user_button_cell text-center"></td>')
                .appendTo(tableCurrentRow);

            var deleteButtonCell = $('<td class="delete_user_button_cell text-center"></td>')
                .appendTo(tableCurrentRow);

            $('<a class= "midi_common_link">Delete Alert</a>')
                .click(() => {
                    this.renderDeleteModal(wbtl);
                }).appendTo(deleteButtonCell);

            $('<a class= "midi_common_link">Edit Alert</a>')
                .click(() => {
                    this.renderModal(wbtl, alert);
                }).appendTo(editButtonCell);
        });

        this.setNoRowsMessage(this.tableBody, 9, true);


        //: Other (non-wave buoy) alerts:
        $tblTitleBar = $('<div>').addClass('clearfix').appendTo(this.container);
        $tblTitleBar.css({ marginTop: 60, marginBottom: 15 });
        $('<h4 class="pull-left">Parameter Alerts</h4>').appendTo($tblTitleBar);
        $('<button type="button" class="btn btn-success pull-right"><i class="fa fa-bell"></i> Add Parameter Alert</button>')
            .appendTo($tblTitleBar)
            .click(() => {
                this.renderModalParameterAlert(null);
            });

        let $table: JQuery = $('<table class="table table-striped table-hover midi_common_table"></table>').appendTo(this.container);
        let $tableHead: JQuery = $('<thead></thead>').appendTo($table);
        let $tableBody: JQuery = $('<tbody></tbody>').appendTo($table);
        let $row: JQuery = null;

        $row = $('<tr>');
        $('<th>Station</th> <th>Sensor</th> <th>Parameter</th> <th class="text-center">Min. Limit</th> <th class="text-center">Max. Limit</th> <th>Email Recipients</th> <th class="text-center">Active</th> <th></th> <th></th>').appendTo($row);
        $row.appendTo($tableHead);
        $tableHead.appendTo($table);
        $tableBody.appendTo($table);

        //: add second table data:
        this.mainSite.staticDataManager.Schema.ParameterRangeEmailAlerts.forEach(_alert => {
            if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(_alert.ParameterId) >= 0) {
                return false; // do not add row as it's deemed to be a buoy specific one!
            }

            let $currentRow = null;
            $currentRow = $('<tr>').appendTo($tableBody);
            $currentRow.data('alertData', _alert);

            // add cells:
            $('<td></td>').attr("data-field", "StationId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "SensorId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "ParameterId").appendTo($currentRow);
            $('<td></td>').attr("data-field", "MinValue").addClass('text-center').appendTo($currentRow);
            $('<td></td>').attr("data-field", "MaxValue").addClass('text-center').appendTo($currentRow);
            $('<td></td>').attr("data-field", "EmailRecipients").appendTo($currentRow);
            $('<td></td>').attr("data-field", "Active").addClass('text-center').appendTo($currentRow);

            this.setRowValuesParameterAlert($currentRow, _alert);

            let editButtonCell = $('<td class="edit_user_button_cell"></td>').appendTo($currentRow);
            let deleteButtonCell = $('<td class="delete_user_button_cell"></td>').appendTo($currentRow);

            $('<a class= "midi_common_link">Delete Alert</a>')
                .click(() => {
                    this.deleteParameterAlert(_alert, $currentRow);
                }).appendTo(deleteButtonCell);

            $('<a class= "midi_common_link">Edit Alert</a>')
                .click(() => {
                    this.renderModalParameterAlert($currentRow);
                }).appendTo(editButtonCell);
        });

        this.setNoRowsMessage($tableBody, 9, false);

        this.container.find('[data-toggle="tooltip"]').tooltip();
        this.loadingContainer.hide();
    }

    private renderModal(wbtl: WaveBuoyTargetLocation = null, alert: ParameterRangeEmailAlert = null) { 
        const { Stations } = this.mainSite.staticDataManager.Schema.ParameterSchema;
        const addNew = wbtl == null;

        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);
        var modalHeaderContent = $('<div class="modal-header"></div>').appendTo(modalContent);

        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);

        if (addNew) {
            $('<h4 class="modal-title">Add New Wave Buoy Alert</h4>')
                .appendTo(modalHeaderContent);
        } else {
            $('<h4 class="modal-title">Edit Wave Buoy Alert</h4>')
                .appendTo(modalHeaderContent);
        }

        this.modalBodyContent = $('<div class="modal-body"></div>')
            .appendTo(modalContent);

        // the containers 

        const stationDropdownContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">Station & Sensor:</span>')
            .appendTo(stationDropdownContainer);

        const emailRecipientContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<div style="margin-top: 5px;"><em>Separate email addresses by semi-colons</em></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope-o fa-fw"></i></span>')
            .appendTo(emailRecipientContainer);

        const targetLatitudeContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">Target Latitude:</span>')
            .appendTo(targetLatitudeContainer);

        const targetLongitudeContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">Target Longitude:</span>')
            .appendTo(targetLongitudeContainer);

        const maxExcursionContainer = $('<div class="input-group midi_ManageUsersPage_input_container"></div>')
            .appendTo(this.modalBodyContent);

        $('<span class="input-group-addon" id="basic-addon1">Max Excursion (m):</span>')
            .appendTo(maxExcursionContainer);

        const activeContainer = $('<div class="input-group midi_ManageUsersPage_input_container">De-activated (do not send emails):&nbsp;</div>')
            .appendTo(this.modalBodyContent);


        // the inputs

        this.emailRecipientInput = $('<textarea class="form-control" placeholder="Email Recipients">')
            .appendTo(emailRecipientContainer);

        this.targetLatitudeInput = $('<input class="form-control" placeholder="DD.ddd" type="number">')
            .appendTo(targetLatitudeContainer);

        this.targetLongitudeInput = $('<input class="form-control" placeholder="DDD.ddd" type="number">')
            .appendTo(targetLongitudeContainer);

        this.maxExcursionInput = $('<input class="form-control" placeholder="" type="number">')
            .appendTo(maxExcursionContainer);

        this.activeInput = $('<input placeholder="" type="checkbox">')
            .appendTo(activeContainer);

        if (addNew) {
            this.selectStationDropdown = $('<select class="form-control"></select>')
                .appendTo(stationDropdownContainer);

            for (let stationId in Stations) {
                const station = Stations[stationId];
                for (let sensorId in station.Sensors) {
                    // don't allow add for an existing alert
                    if (this.mainSite.staticDataManager.Schema.WaveBuoyTargetLocations
                        .some(x => x.StationId == stationId && x.SensorId == sensorId)) {
                        continue;
                    }
                    const sensor = station.Sensors[sensorId];
                    if ("Buoy_Latitude/deg" in sensor.Parameters) {
                        this.selectStationDropdown.append('<option value="' + stationId + "," + sensorId + '">' + station.Station.Label + " - " + sensorId + '</option>');
                    }
                }
            }
        } else {
            $('<input readonly type="text" class="form-control">')
                .val(Stations[wbtl.StationId].Station.Label + " - " + wbtl.SensorId)
                .appendTo(stationDropdownContainer);

            this.emailRecipientInput.val(alert.EmailRecipients.join(";"));
            this.targetLatitudeInput.val(wbtl.Latitude.toString());
            this.targetLongitudeInput.val(wbtl.Longitude.toString());
            this.maxExcursionInput.val(alert.MaxValue.toString());
            if (!alert.Active) {
                this.activeInput.attr('checked', 'checked');
            }
        }
        
        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);
        $('<button type="button" class="btn btn-success">Submit</button>')
            .appendTo(modalFooterContent)
            .click(() => {
                let stationId, sensorId = null;

                const errors: string[] = [];

                if (addNew) {
                    const stationVal = this.selectStationDropdown.val();
                    if (!stationVal) {
                        errors.push("Station and sensor must be chosen");
                        this.selectStationDropdown.addClass("midi_common_validation_warning");
                    } else {
                        const split: string[] = stationVal.split(",");
                        stationId = split[0];
                        sensorId = split[1];
                    }
                } else {
                    stationId = wbtl.StationId;
                    sensorId = wbtl.SensorId;
                }

                const emailRecipientsSplit: string[] = (this.emailRecipientInput.val() as string).split(";").map(x => x.trim());
                const latitude = parseFloat(this.targetLatitudeInput.val());
                const longitude = parseFloat(this.targetLongitudeInput.val());
                const excursion = parseFloat(this.maxExcursionInput.val());

                const req: SetWaveBuoyExcursionAlarmRequest = {
                    StationId: stationId,
                    SensorId: sensorId,
                    Active: !this.activeInput.is(':checked'),
                    Latitude: latitude,
                    Longitude: longitude,
                    EmailRecipients: emailRecipientsSplit,
                    MaxExcursion: excursion,
                };

                // clear previous validation errors
                $('.midi_common_validation_warning', this.modalContent).removeClass('midi_common_validation_warning');

                if (isNaN(req.Latitude) || req.Latitude > 90 || req.Latitude < -90) {
                    errors.push("Latitude must be valid");
                    this.targetLatitudeInput.addClass("midi_common_validation_warning");
                }

                if (isNaN(req.Longitude) || req.Longitude > 180 || req.Longitude < -180) {
                    errors.push("Longitude must be valid");
                    this.targetLongitudeInput.addClass("midi_common_validation_warning");
                }

                if (isNaN(req.MaxExcursion) || req.MaxExcursion < 0) {
                    errors.push("Excursion must be valid");
                    this.maxExcursionInput.addClass("midi_common_validation_warning");
                }

                if (req.EmailRecipients.some(x => !this.validateEmailAddresses(x))) {
                    errors.push("Enter valid email addresses separated by semi-colons");
                    this.emailRecipientInput.addClass("midi_common_validation_warning");
                }

                this.resetErrorText(errors);

                if (errors.length > 0) {
                    return;
                }

                setWaveBuoyExcursionAlarm(req, (err) => {
                    if (err) {
                        errors.push("Server error: " + err.Message);
                        this.resetErrorText(errors);
                    }
                    this.modal.modal('hide');
                    this.refresh();
                });
            });


        this.modal.modal('show');     
    }

    private renderDeleteModal(wbtl: WaveBuoyTargetLocation) {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        this.modal = $('<div id="myModal" class="modal fade"></div>')
            .appendTo('body');

        var modalDialog = $('<div class="modal-dialog"></div>').appendTo(this.modal);

        var modalContent = $('<div class="modal-content"></div>')
            .appendTo(modalDialog);

        var modalHeaderContent = $('<div class="modal-header"></div>')
            .appendTo(modalContent);

        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>')
            .appendTo(modalHeaderContent);

        $('<h4 class="modal-title">Confirm Delete</h4>')
            .appendTo(modalHeaderContent);

        var modalBodyContent = $('<div class="modal-body"></div>')
            .appendTo(modalContent);

        $('<p>Are you sure you want to delete this wave buoy alert from the system?<p>').appendTo(modalBodyContent);

        var modalFooterContent = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>').appendTo(modalFooterContent);
        $('<button type="button" class="btn btn-success">Delete</button>')
            .click(() => {
                this.resetErrorText([]);

                deleteWaveBuoyExcursionAlarm(wbtl.StationId, wbtl.SensorId, (err) => {
                    if (err) {
                        this.resetErrorText(["Server error: " + err.Message]);
                    }
                    this.modal.modal('hide');
                    this.refresh();
                });
            })
            .appendTo(modalFooterContent);

        this.modal.modal('show');     
    }

    private setNoRowsMessage($tableBody: JQuery, colsCount: number = 9, isWaveBuoy: boolean = true): void {
        $tableBody.find('tr.no-rows-message-row').remove();
        if ($tableBody.find('tr:not(.no-rows-message-row)').length == 0) {
            let $row: JQuery = $('<tr>').addClass('no-rows-message-row').appendTo($tableBody);
            let txt: string = isWaveBuoy ? 'There are no Wave Buoy Alerts yet.<br>Use the button above to add a new Wave Buoy Alert.' : 'There are no Parameter Alerts yet.<br>Use the button above to add a new Parameter Alert.';
            $(`<td colspan="${colsCount}" class="text-center text-muted"><div style="margin:40px 0;"><i class="fa fa-lg fa-info-circle"></i> ${txt}</div></td>`).appendTo($row);
        }
    }

    /**
     * "Normal" Parameter Alerts: set the contents of the cells in the table..
     * @param $row
     * @param _alert
     */
    private setRowValuesParameterAlert($row: JQuery, _alert: ParameterRangeEmailAlert): void {
        let names: AlertNamesStruct = this.getAlertNames(_alert);
        $row.find('td[data-field="StationId"]').text(names.station);
        $row.find('td[data-field="SensorId"]').text(names.sensor);
        $row.find('td[data-field="ParameterId"]').text(names.parameter);
        $row.find('td[data-field="MinValue"]').text(_alert.MinValue == null ? '' : _alert.MinValue);
        $row.find('td[data-field="MaxValue"]').text(_alert.MaxValue == null ? '' : _alert.MaxValue);
        $row.find('td[data-field="EmailRecipients"]').text(_alert.EmailRecipients.join(", "));
        $row.find('td[data-field="Active"]').html(_alert.Active ? '<i class="fa fa-fw fa-check"></i>' : '<i class="fa fa-fw fa-times"></i>');
    }

    private renderModalParameterAlert(tableRow: JQuery = null): void {
        const _alert: ParameterRangeEmailAlert = tableRow == null ? null : tableRow.data('alertData');
        const StationsByRegion: IStationsByRegion[] = this.mainSite.getStationsByRegions(true);
        const addNew = _alert == null;

        let modalDataClone: ParameterRangeEmailAlert = _alert !== null ? { ..._alert } : { StationId: '', SensorId: '', ParameterId: '', Active: true, EmailRecipients: [], MaxValue: null, MinValue: null }; //: use a clone or new object to help update data

        // console.info("EDIT PARAM ALERT", { alert: _alert, $row: tableRow });

        if (this.modal) {
            this.modal.remove();
            this.modal = null;
        }

        let _page: ManageAlertsPage = this;

        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        let modalDialog: JQuery = $('<div class="modal-dialog"></div>').appendTo(this.modal);
        let modalContent: JQuery = $('<div class="modal-content"></div>').appendTo(modalDialog);

        //: Modal Header:
        let modalHeaderContent: JQuery = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>').appendTo(modalHeaderContent);
        if (addNew) {
            $('<h4 class="modal-title">Add New Parameter Alert</h4>').appendTo(modalHeaderContent);
        } else {
            $('<h4 class="modal-title">Edit Parameter Alert</h4>').appendTo(modalHeaderContent);
        }

        //: Modal Content:
        this.modalBodyContent = $('<div class="modal-body"></div>').appendTo(modalContent);
        let modalFeedbackWrap: JQuery = $('<div class="modal-feedback"></div>').appendTo(this.modalBodyContent);

        //: Form wrapper:
        let modalForm: JQuery = $('<form></form>').appendTo(this.modalBodyContent);
        modalForm.addClass("form-horizontal");
        modalForm.on("submit", (e) => {
            return false;
        });

        //: Field: StationId
        const stationRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const stationLbl: JQuery = $('<label class="col-sm-3 control-label">Station:</label>').appendTo(stationRow);
        const stationCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(stationRow);
        this.modalFieldStationId = $('<select class="form-control"></select>').appendTo(stationCol);

        if (addNew) {
            this.modalFieldStationId.append('<option value="" selected="selected" disabled>Please select a Station...</option>');
        }

        StationsByRegion.forEach(region => {
            let $optgroup: JQuery = $('<optgroup></optgroup>').attr("label", region.Region.Label);
            region.Stations.forEach(station => {
                let $opt: JQuery = $('<option value="' + station.Id + '">' + station.Label + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.StationId == station.Id) {
                    $opt.prop("selected", true);
                }
                $opt.appendTo($optgroup);
            });

            $optgroup.appendTo(this.modalFieldStationId);
        });

        this.modalFieldStationId.on("change", (e) => {
            const _stationId: string = $(e.target).val();
            modalDataClone.StationId = _stationId;

            let _sensors: { [sensorId: string]: ParameterSchemaSensor } = {};

            if (_stationId && _stationId !== null && _stationId !== '') {
                _sensors = _page.mainSite.getStationSensors(_stationId);
            }

            this.modalFieldSensor.find('option').remove();
            let count: number = 0;
            for (let sensorId in _sensors) {
                let $opt: JQuery = $('<option value="' + sensorId + '">' + sensorId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.SensorId == sensorId) {
                    $opt.prop("selected", true);
                }
                $opt.appendTo(this.modalFieldSensor);
                count++;
            }

            if (count == 0 || modalDataClone.SensorId == '') {
                let $opt: JQuery = $('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
                $opt.prependTo(this.modalFieldSensor);
            }

            //: Trigger change on Sensor field to ensure that the list of Param Groups gets populated:
            this.modalFieldSensor.trigger("change");
        });



        //: Field: Sensor
        const sensorRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const sensorLbl: JQuery = $('<label class="col-sm-3 control-label">Sensor:</label>').appendTo(sensorRow);
        const sensorCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(sensorRow);
        this.modalFieldSensor = $('<select class="form-control"></select>').appendTo(sensorCol);

        if (addNew) {
            this.modalFieldSensor.append('<option value="" selected="selected" disabled>Please select a Station, then a Sensor...</option>');
        }

        //: trigger onchange of station to populate list of sensors:
        this.modalFieldStationId.trigger("change");

        this.modalFieldSensor.on("change", (e) => {
            const _sensorId: string = $(e.target).val();
            modalDataClone.SensorId = _sensorId;

            let _paramGroups: string[] = [];
            let _params: { [parameterId: string]: ParameterInfo } = {};

            if (_sensorId && _sensorId !== null && _sensorId !== '') {
                _paramGroups = _page.mainSite.getStationParameterGroups(modalDataClone.StationId, modalDataClone.SensorId);
                _params = _page.mainSite.getStationSensorParameters(modalDataClone.StationId, modalDataClone.SensorId);
            }

            this.modalFieldParameterGroup.find('option').remove();
            let count: number = 0;
            for (let paramId in _params) {
                let pi: ParameterInfo = _params[paramId];
                let pv: ParameterVariant = pi.Variants[0]; //: NB: this assumes always the first variant is set (which is expected)!!  TODO: check this is right with Ben!!
                let $opt: JQuery = $('<option value="' + paramId + '">' + paramId + '</option>');
                if (modalDataClone && modalDataClone !== null && modalDataClone.ParameterId == paramId) {
                    $opt.prop("selected", true);
                }
                if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(paramId) >= 0) {
                    $opt.prop("disabled", true);
                    $opt.text(`${paramId} [DISABLED - Use Buoy Alerts instead]`);
                }
                $opt.appendTo(this.modalFieldParameterGroup);
                count++;
            }

            if (count == 0 || modalDataClone.ParameterId == '') {
                let $opt: JQuery = $('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter...</option>');
                $opt.prependTo(this.modalFieldParameterGroup);
            }
        });



        //: Field: ParamterGroup
        const pgRow: JQuery = $('<div class="form-group"></div>').appendTo(modalForm);
        const pgLbl: JQuery = $('<label class="col-sm-3 control-label">Parameter:</label>').appendTo(pgRow);
        const pgCol: JQuery = $('<div class="col-sm-9"></div>').appendTo(pgRow);
        this.modalFieldParameterGroup = $('<select class="form-control"></select>').appendTo(pgCol);

        if (addNew) {
            this.modalFieldParameterGroup.append('<option value="" selected="selected" disabled>Please select a Sensor, then a Parameter Group...</option>');
        }

        //: trigger onchange of sensor to populate list of param groups:
        this.modalFieldSensor.trigger("change");

        this.modalFieldParameterGroup.on("change", (e) => {
            const _parameterGroup: string = $(e.target).val();
            modalDataClone.ParameterId = _parameterGroup;
        });


        //: other field groups:
        let $row: JQuery = null;
        let $lbl: JQuery = null;
        let $col: JQuery = null;
        let $hlp: JQuery = null; //: helper which is intended for typing, not re-usable elements..

        //: .Active
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label"></label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        $hlp = $('<label></label>').appendTo($('<div class="checkbox"></div>').appendTo($col));
        const $inputActive: JQuery = $('<input type="checkbox" />').appendTo($hlp);
        $('<span>Active <em class="text-muted">(send emails if limits are reached)</em></span>').disableSelection().appendTo($hlp);
        $inputActive.prop("checked", modalDataClone.Active).on("change", (e) => {
            modalDataClone.Active = $(e.target).is(':checked');
        });

        //: .Title (optional)
        /*
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Title:</label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        const $inputTitle: JQuery = $('<input type="text" class="form-control" placeholder="Title (optional)" />').appendTo($col);
        $inputTitle.val(modalDataClone.Title);
        */

        //: .EmailRecipients
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Recipients:</label>').appendTo($row);
        $col = $('<div class="col-sm-9"></div>').appendTo($row);
        const $inputEmailRecipients: JQuery = $('<textarea type="text" class="form-control" placeholder="Email recipients (separated by semi-colon)"></textarea>').appendTo($col);
        $('<span class="help-block"><em>Separate email addresses by semi-colons</em></span>').disableSelection().appendTo($col);
        $inputEmailRecipients.val(modalDataClone.EmailRecipients ? modalDataClone.EmailRecipients.join(";") : '').on("change", (e) => {
            modalDataClone.EmailRecipients = ($(e.target).val() as string).split(";").map(x => x.trim());
        });

        //: Thresholds (.MinValue & .MaxValue)
        $row = $('<div class="form-group"></div>').appendTo(modalForm);
        $lbl = $('<label class="col-sm-3 control-label">Limits:</label>').appendTo($row);
        $col = $('<div class="col-sm-4"></div>').appendTo($row);
        $hlp = $('<div>').addClass('input-group').appendTo($col);
        $('<span class="input-group-addon">Min:</span>').appendTo($hlp);
        const $inputMinValue: JQuery = $('<input type="text" class="form-control" placeholder="Min" />').appendTo($hlp);
        $col = $('<div class="col-sm-4 col-sm-offset-1"></div>').appendTo($row);
        $hlp = $('<div>').addClass('input-group').appendTo($col);
        $('<span class="input-group-addon">Max:</span>').appendTo($hlp);
        const $inputMaxValue: JQuery = $('<input type="text" class="form-control" placeholder="Max" />').appendTo($hlp);

        $inputMinValue.val(modalDataClone.MinValue == null ? '' : modalDataClone.MinValue.toString()).on("change", (e) => {
            let _val = parseFloat($(e.target).val() as string);
            if (isNaN(_val)) {
                _val = null;
            }
            modalDataClone.MinValue = _val;
        });

        $inputMaxValue.val(modalDataClone.MaxValue == null ? '' : modalDataClone.MaxValue.toString()).on("change", (e) => {
            let _val = parseFloat($(e.target).val() as string);
            if (isNaN(_val)) {
                _val = null;
            }
            modalDataClone.MaxValue = _val;
        });


        //: prevent PrimaryKey changes in case we're in edit mode:
        if (!addNew) {
            this.modalFieldStationId.prop("disabled", true);
            this.modalFieldSensor.prop("disabled", true);
            this.modalFieldParameterGroup.prop("disabled", true);
        }

        //: additional event handlers:
        modalForm.find(':input').on('change', (e) => {
            modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
            modalFeedbackWrap.html('').hide();
            modalForm.addClass('data-changed');
            window.onbeforeunload = () => {
                return "You have unsaved modifications on this page. If you navigate away from the page, your modifications will not be saved.";
            };
        });


        //: Footer:
        let modalFooterContent: JQuery = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-success">Save</button>')
            .appendTo(modalFooterContent)
            .click(() => {
                modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
                modalFeedbackWrap.html('').hide();

                let errors: string[] = [];

                //: validations:
                if (modalDataClone.StationId == '' || modalDataClone.StationId == null) {
                    errors.push("Please select a Station.");
                    this.modalFieldStationId.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }

                if (modalDataClone.SensorId == '' || modalDataClone.SensorId == null) {
                    errors.push("Please select a Sensor.");
                    this.modalFieldSensor.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }

                if (modalDataClone.ParameterId == '' || modalDataClone.ParameterId == null) {
                    errors.push("Please select a Parameter.");
                    this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                } else {
                    if (this.WAVE_BUOY_PARAMETER_IDS.indexOf(modalDataClone.ParameterId) >= 0) {
                        errors.push("The selected Parameter is intended for Wave Buoys. Please use specific Wave Buoy Alerts instead of normal Parameter Alerts for this.");
                        this.modalFieldParameterGroup.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                    }
                }

                if (modalDataClone.Active == true && modalDataClone.MinValue == null && modalDataClone.MaxValue == null) {
                    errors.push("Please provide at least one limit to use for this alert.");
                    $inputMinValue.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                    $inputMaxValue.addClass('midi_common_validation_warning');
                }

                let _emailErrors: string[] = [];
                let _emailsCount: number = 0;
                modalDataClone.EmailRecipients.forEach(email => {
                    let valid: boolean = this.validateEmailAddresses(email);
                    if (!valid) {
                        _emailErrors.push(email);
                    } else {
                        _emailsCount++;
                    }
                });
                if (_emailErrors.length > 0 || _emailsCount == 0) {
                    errors.push("Please check that email recipients are all valid email addresses, and that there is at least one email provided.");
                    $inputEmailRecipients.addClass('midi_common_validation_warning').closest('.form-group').addClass('has-error');
                }

                if (errors.length > 0) {
                    modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Please correct the below errors:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                    return false;
                }

                if (errors.length == 0) {
                    setParameterAlert(modalDataClone, (err) => {
                        if (err) {
                            errors.push("Server error: " + err.Message);
                            modalFeedbackWrap.html('<div class="alert alert-danger"><i class="fa fa-lg fa-warning"></i> <strong>Unable to save your changes:</strong><br><br>- ' + errors.join('<br>- ') + '</div>').show();
                        } else {
                            modalForm.removeClass('data-changed');
                            this.modal.modal('hide');

                            if (addNew) {
                                this.refresh();
                            } else {
                                tableRow.data('alertData', modalDataClone);
                                this.setRowValuesParameterAlert(tableRow, modalDataClone);
                                tableRow.addClass("bg-success");
                                setTimeout(() => {
                                    tableRow.removeClass("bg-success");
                                }, 3000);
                            }
                        }
                    });
                }
            });

        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>').appendTo(modalFooterContent);

        if (!addNew) {
            $('<button type="button" class="btn btn-danger pull-left">Delete this Parameter Alert</button>')
                .prependTo(modalFooterContent)
                .click(() => {
                    modalForm.find('.has-error, .has-warning, .midi_common_validation_warning').removeClass('has-error has-warning midi_common_validation_warning');
                    modalFeedbackWrap.html('').hide();

                    this.deleteParameterAlert(modalDataClone, tableRow);
                });
        }

        this.modal.modal('show');

        this.modal.on('hide.bs.modal', (e) => {
            if (modalForm.hasClass('data-changed')) {
                let conf = confirm("You have unsaved changes on this popup.\n\nAre you sure you wish to cancel and close the popup?");
                if (!conf) {
                    return false;
                }
            }
        });

        this.modal.on('hidden.bs.modal', (e) => {
            this.modal.remove();
            this.modal = null;
            window.onbeforeunload = null;
        });
    }

    /**
     * This method will prompt the user (via browser prompt rather than modal, as this could be triggered from within the modal) to delete the given Alert.
     * @param _alert The Alert data in full to delete.
     * @param $row The table row to remove upon successful deletion (to prevent full refresh).
     */
    private deleteParameterAlert(_alert: ParameterRangeEmailAlert, $row: JQuery): void {
        let names: AlertNamesStruct = this.getAlertNames(_alert);

        // console.info("DELETE PARAM ALERT", { alert: _alert, $row: $row });

        let conf = confirm(`Are you certain you wish to permanently delete the Alert for ${names.station} / ${names.sensor} / ${names.parameter}?`);
        if (conf) {
            deleteParameterAlert(_alert, (err: RESTError) => {
                if (err) {
                    alert(`Error while trying to delete the Alert: ${err.Message}`);
                } else {
                    let $tbody: JQuery = $row.closest('tbody');
                    $row.data('alertData', null);
                    $row.remove();
                    this.setNoRowsMessage($tbody, 9, false);
                    try {
                        if (this.modal) {
                            this.modal.modal('hide');
                        }
                    } catch (_err) {
                        console.info('Unable to hide modal, most likely because it does not exist.');
                    }
                }
            });
        }
    }

    /**
     * A helper function to try retrieving display names for Station, Sensor & Parameter for a give Alert.
     * @param _alert
     */
    private getAlertNames(_alert: ParameterRangeEmailAlert): AlertNamesStruct {
        let _out: AlertNamesStruct = {
            station: _alert.StationId,
            sensor: _alert.SensorId,
            parameter: _alert.ParameterId
        };

        try {
            _out.station = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[_alert.StationId].Station.Label;
        } catch (_err) {
            // no error or action as this is not very important.
        }

        try {
            _out.sensor = this.mainSite.staticDataManager.Schema.ParameterSchema.Stations[_alert.StationId].Sensors[_alert.SensorId].SensorDefinition.DisplayName;
            if (!_out.sensor) {
                _out.sensor = _alert.SensorId;
            }
        } catch (_err) {
            // no error or action as this is not very important.
        }


        return _out;
    }

    private validationErrorText: JQuery = null;

    private resetErrorText(errors: string[]) {
        if (this.validationErrorText) {
            this.validationErrorText.remove();
        }

        if (errors.length > 0) {
            this.validationErrorText = $('<div class="alert alert-danger midi_ManageUsersPage_warningBox"></div>')
                .appendTo(this.modalBodyContent);
            errors.forEach(err => {
                this.validationErrorText.append('<p><i class="fa fa-exclamation-triangle"></i>&nbsp;' + err + '</p>');
            });
        }
    }

    private validateEmailAddresses(email: string): boolean {
        //currently allows up to xx@icon.software (NB {2,8} length for the .something part
        var validEmailFormatRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,8}(?:\.[a-z]{2})?)$/i;
        return validEmailFormatRegex.test(email);
    }
}